<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-12">
        <b-field>
          <form-textarea :label="`${$t('interface.description')} *`" v-model="form.description"></form-textarea>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('issueTracker.priority')} *`" v-model="form.priority">
            <option value="low">{{ $t('workflow.priorities.low') }}</option>
            <option value="medium">{{ $t('workflow.priorities.medium') }}</option>
            <option value="high">{{ $t('workflow.priorities.high') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('issueTracker.category')} *`" v-model="form.category">
            <option v-for="category in categories" :value="category.id">
              {{ category.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-datepicker :label="$t('issueTracker.term')" v-model="form.term"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field>
          <form-timepicker :label="$t('interface.time')" v-model="form.term"></form-timepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field class="file" style="margin-top: 12px;">
          <b-upload v-model="form.file">
            <a class="button is-warning">
              <span>{{ $t('issueTracker.file') }}</span>
            </a>
          </b-upload>
          <span class="file-name">
            <template v-if="form.file">{{ form.file.name }}</template>
            <template v-if="form.file__name && !form.file">{{ form.file__name }}</template>
            <template v-if="!form.file__name && !form.file">{{ $t('interface.noFileSelected') }}</template>
          </span>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDateTime} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'

  const defaultIssueData = {
    description: '',
    priority: 'low',
    term: new Date(),
    category: null,
    file: null
  }

  export default {
    props: ['issueData', 'editMode'],
    components: {EmployeeSelect},
    data() {
      return {
        form: this.issueData || {...defaultIssueData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        let isValid = true
        this.errors = []
        if (this.form.description === '' || this.form.category === null) {
          this.errors.push(this.$t('interface.requiredFields'))
          isValid = false
        }
        return isValid
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            term: prepareDateTime(this.form.term)
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    mounted() {
      this.$store.dispatch('IssueTracker/getRelations', this.$route.params.projectId)
    },
    computed: {
      ...mapState('IssueTracker', ['categories'])
    },
    watch: {
      issueData(data) {
        this.form = data
      }
    }
  }
</script>
